<template>
  <div :class="wrapperClasses">
    <div
      class="product-item__gallery"
      @mouseover="onGalleryHovered(true)"
      @mouseleave="onGalleryHovered(false)"
    >
      <ProductCardGallery
        :product="selectedProduct"
        :includes-aspect-ratio="includesAspectRatio"
        :onPlp="onPlp"
        :image-hovered="galleryHovered"
        @focused="onGalleryFocus"
      >
        <template #placeholderMedia>
          <slot name="placeholderMedia" />
        </template>
      </ProductCardGallery>
      <transition name="fade">
        <ProductQuickAdd 
          v-if="showQuickAdd"
          :onclick="toggleSwatches"
        />
        <ProductCardSizes
          v-if="showProductSizes"
          :context-url="selectedProduct.context_url"
          :sizes="productSizes.values"
          :size-option-key="sizeOptionKey"
          :variants="selectedProduct.variants"
          :toggleSwatches="toggleSwatches"
          :product="selectedProduct"
        />
      </transition>
    </div>
    <ProductCardBadges :product="badgeData" :key="badgeData.title" />
    <div class="product-item__details-wrapper relative">
      <ProductCardDetails :onPlp="onPlp" :product="selectedProduct" :initialProduct="product" :updateProduct="updateProduct">
        <template #wishlist>
          <slot name="wishlist" />
        </template>
      </ProductCardDetails>
    </div>
  </div>
</template>

<script>
  import ProductCardGallery from './ProductCardGallery.vue';
  import ProductCardBadges from './ProductCardBadges.vue';
  import ProductCardDetails from './ProductCardDetails.vue';
  import ProductCardQuickShopBtn from './ProductCardQuickShopBtn.vue';
  import ProductCardSizes from './ProductCardSizes.vue';
  import ProductQuickAdd from './ProductQuickAdd.vue';
  import ProductCardPrice from './ProductCardPrice.vue';

  export default {
    components: {
      ProductCardGallery,
      ProductCardBadges,
      ProductCardDetails,
      ProductCardQuickShopBtn,
      ProductCardSizes,
      ProductQuickAdd,
      ProductCardPrice
    },

    props: {
      aspectRatio: {
        type: String,
      },

      onPlp: {
        type: Boolean,
        default: false,
      },

      product: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        galleryHovered: false,
        includesAspectRatio: '',
        sizeNames: ['size', 'shoe size', 'size shoe'],
        showSwatches: false,
        selectedProduct: this.product,
      };
    },

    computed: {
      isMobile() {
        return window.innerWidth < 768;
      },

      showProductSizes() {
        return this.onPlp && this.showSwatches && this.galleryHovered;
      },

      showQuickAdd() {
        return this.onPlp && !this.showSwatches && this.galleryHovered;
      },

      showQuickShopBtn() {
        return window.bvaccel.data.quick_shop_enabled && this.product.available;
      },

      sizeOptionKey() {
        if (!this.productSizes) {
          return null;
        }

        return `option_${this.productSizes.position}`
      },

      wrapperClasses() {
        const imageAspectRatio = this.aspectRatio;

        return {
          'product-item': true,
          [`product-item--${imageAspectRatio}`]: this.includesAspectRatio,
        };
      },
      badgeData() {
        return this.selectedProduct
      }
    },

    created() {
      this.initSettings();
      if (this.isMobile) {
        this.galleryHovered = true;
      }
    },

    methods: {
      hoverGallery(hovered) {
        this.galleryHovered = hovered;
      },

      initSettings() {
        this.includesAspectRatio = this.aspectRatio && this.aspectRatio !== 'natural';
        this.productSizes = this.product.options_with_values.find((option) => this.sizeNames.includes(option.name.toLowerCase())) || {values: []}
      },

      updateProduct(color){
        document.dispatchEvent(new 
        CustomEvent("swym:refresh"));

        const currentProduct = this.product.color_variants.find(product => {
          return product.url === color.url
        })
          this.selectedProduct = currentProduct;
          this.productSizes = this.product.options_with_values.find((option) => this.sizeNames.includes(option.name.toLowerCase())) || {values: []}
      },

      onGalleryFocus(focused) {
        this.hoverGallery(focused);
      },

      onGalleryHovered(hovered) {
        if (!this.isMobile) {
          this.galleryHovered = hovered;
        }
      },
      
      toggleSwatches(event) {
        if (event.target.className !== 'disabled'){
          this.showSwatches = !this.showSwatches;
        }
      },
    },
  };
</script>

<style></style>
